import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { AppComponent } from "./app.component";
import { RoutingModule } from "./modules/routing/routing.module";
import { LoadingBarComponent } from "./components/loading-bar/loading-bar.component";
import { SessionExpiredComponent } from "./components/session-expired/session-expired.component";
import { RouterModule } from '@angular/router';

import { WelcomeComponent } from "./components/welcome/welcome.component";
import { CustomerAcknowledgementFormComponent } from './components/customer-acknowledgement-form/customer-acknowledgement-form.component';
import { CaHeaderComponent } from './components/ca-header/ca-header.component';
import { CaFooterComponent } from './components/ca-footer/ca-footer.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { OrderExpiredPageComponent } from './components/order-expired-page/order-expired-page.component';
import { ConsentFooterComponent } from "./components/consent/consent-footer/consent-footer.component";
import { ConsentComponent } from "./components/consent/consent.component";
import { ConsentHeaderComponent } from "./components/consent/consent-header/consent-header.component";

@NgModule({ declarations: [
        AppComponent,
        LoadingBarComponent,
        SessionExpiredComponent,
        WelcomeComponent,
        CustomerAcknowledgementFormComponent,
        CaHeaderComponent,
        CaFooterComponent,
        OrderExpiredPageComponent,
        ConsentComponent,
        ConsentHeaderComponent,
        ConsentFooterComponent
    ],
    bootstrap: [AppComponent], imports: [RouterModule,
        BrowserModule,
        BrowserAnimationsModule,
        RoutingModule,
        FormsModule,
        ReactiveFormsModule.withConfig({ warnOnNgModelWithFormControl: "never" }),
        NgbModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class AppModule {}
